"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toIsoDateIfNotNull = exports.normalizeIfNotNullOrEmpty = exports.localStorageAnonymizedPiiDataProvider = void 0;
const hash_string_1 = require("../../hash-string");
function normalizeIfNotNullOrEmpty(value) {
    return value && value?.length > 0 ? (0, hash_string_1.normalize)(value) : null;
}
exports.normalizeIfNotNullOrEmpty = normalizeIfNotNullOrEmpty;
function toIsoDateIfNotNull(value) {
    if (value && value?.length > 0) {
        const dateArray = value.split('/');
        if (dateArray.length === 3) {
            return `${dateArray[2]}-${dateArray[0]}-${dateArray[1]}`;
        }
        return null;
    }
    return null;
}
exports.toIsoDateIfNotNull = toIsoDateIfNotNull;
const localStorageAnonymizedPiiDataProvider = {
    readPiiContextData: () => {
        try {
            const hcData = JSON.parse(window.localStorage.getItem('hc') || 'null');
            const { contact } = hcData;
            const firstMember = hcData.members?.length > 0 ? hcData.members[0] : null;
            return {
                email: normalizeIfNotNullOrEmpty(contact?.email_address),
                phoneNumber: normalizeIfNotNullOrEmpty(contact?.phone_home),
                dob: toIsoDateIfNotNull(firstMember?.dob),
                gender: firstMember?.gender?.toString() || null,
                zipCode: hcData.location?.zip_code || null,
            };
        }
        catch (error) {
            return {
                email: null,
                phoneNumber: null,
                dob: null,
                gender: null,
                zipCode: null,
            };
        }
    },
};
exports.localStorageAnonymizedPiiDataProvider = localStorageAnonymizedPiiDataProvider;
//# sourceMappingURL=local-storage-data-provider.js.map